import Monke from "../../img/2025/Sugo.jpeg";
const Puzzle2 = () => {
  return (
    <main style={{ padding: 24 }}>
      <h1>🍝 2. Sugo der Sossige – Das Sortierrätsel</h1>

      <p>
        Ciao bella! Ich bin Sugo – der Sossigste der Bande! Ich rühre nicht nur
        Tomaten, ich rühre auch dein Hirn durcheinander! Mach dich bereit – mein
        Rätsel ist heiß, würzig und klebrig!
      </p>
      <img src={Monke} style={{ maxWidth: "100%", marginBottom: "32px" }} />
      <p>
        <b style={{ fontSize: "1.2em" }}>
          Ich hab ganz viele Saucen:
          <ul>
            <li>Mayo</li>
            <li>Ketchup</li>
            <li>Senf</li>
            <li>Sriracha</li>
            <li>Barbecue</li>
            <li>Chipeño</li>
          </ul>
          An welcher Stelle ist der Senf, wenn man meine Saucen Alphabetisch
          ordnen würde?
        </b>
      </p>
      <p>
        Du magst es heiss? Schau doch mal bei Fugo vorbei, der ist beim Ofen.
      </p>
    </main>
  );
};

export default Puzzle2;
